import { render } from "./KPIEditModal.vue?vue&type=template&id=72af5f56&scoped=true"
import script from "./KPIEditModal.vue?vue&type=script&lang=js"
export * from "./KPIEditModal.vue?vue&type=script&lang=js"

import "./KPIEditModal.vue?vue&type=style&index=0&id=72af5f56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72af5f56"]])

export default __exports__